import { useTranslation } from 'react-i18next'
import { LoginPage } from '@structural-climbing/auth'
import { inviteReturn } from '../features/team/inviteReturn'

/**
 * The gym app's login page, with a refusal message that fits how the person
 * got here.
 *
 * Someone refused straight after tapping "Set up your account" on an invite
 * signed in as an account the invite was not sent to. Telling them to "use the
 * link in your email" is no help: that is what they just did. AcceptInvitePage
 * leaves the invite link in sessionStorage before it redirects, which is how
 * this page knows, and how signing out leads back to the invite.
 */
export function GymLoginPage() {
  const { t } = useTranslation()
  const invite = inviteReturn()
  if (invite === null) return <LoginPage errorMessage={t('auth.gymPortalInvitedOnly')} />

  const invited = new URLSearchParams(invite.slice(invite.indexOf('?'))).get('email')
  return (
    <LoginPage
      errorMessage={
        invited
          ? t('acceptInvite.loginRefused', { invited })
          : t('acceptInvite.loginRefusedNoEmail')
      }
    />
  )
}
